// ControlCaptchaFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import CaptchaControlView  from 'advanced-visuals/CaptchaControlView.js';


//=============================================================================
//
// Creates a text area input control, given a factoryService
// parameter key and a layout position. The factory key defines the
// control appearance through its template. It defines the initial rectangle
// of the control via a width and height from the factory parameter.
//
// Brad Trebilcock, January 17, 2016
//
//=============================================================================
class ControlCaptchaFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.length = '7';
        attributes.backgroundColor = '#FFFFFF';
		attributes.minWidth = 10;
		attributes.lowestHeight = 30;
        this.resolveForInitialMinHeight(attributes);
		attributes.captchaImage = null;

		// // PF-3935 We need this flag in order to distinguish the first drop on the canvas and tell the server to dont retrieve a new image while the control is moved.
		attributes.keepText = false;
        attributes.translateProps = [
            {key:"accessDesc", label:"Accessibility Description"}
        ];

        const view = new CaptchaControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlCaptchaFactory = new ControlCaptchaFactory();

export default controlCaptchaFactory;